function getUrl(area, action, id) {
    return `/api/${area}/${action}/${id}`;
}

export default {
    getUrl: getUrl
};